import { useCallback } from 'react';

import type { CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables } from '../graphql/__generated__';
import {
  useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesLazyQuery,
  useCrmManagement_SalesCoverage_UnderwriterEmployeesLazyQuery,
} from '../graphql/__generated__';

export function useSalesCoverageUnderwriterEmployeesGridQuery(tenantId?: string) {
  const [loadRowsAsCustomer] = useCrmManagement_SalesCoverage_UnderwriterEmployeesLazyQuery();
  const [loadRowsAsAdmin] = useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesLazyQuery();

  return useCallback(
    async (variables: CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables) => {
      if (tenantId) {
        const response = await loadRowsAsAdmin({
          variables: { ...variables, tenantId },
          fetchPolicy: 'no-cache',
        });
        return {
          ...response,
          data: {
            ...response.data,
            underwriterEmployees: {
              ...response.data?.adminUnderwriterEmployees,
            },
          },
        };
      } else {
        return await loadRowsAsCustomer({ variables, fetchPolicy: 'no-cache' });
      }
    },
    [loadRowsAsAdmin, loadRowsAsCustomer, tenantId]
  );
}
